import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate
} from "react-router-dom";
import Navbar from "./Components/Navbar";
import Home from "./Pages/Home";
import AuthFlow from "./Pages/AuthFlow";
import Dashboard from "./Pages/Dashboard";
import Account from "./Pages/Account";
import ForgotPasswordPage from "./Pages/ForgotPassword";
import ResetPasswordPage from "./Pages/ResetPasswordPage";
import ContactUsPage from "./Pages/ContactUsPage";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import Footer from "./Components/Footer";
import Sidebar from "./Components/Sidebar";
import MobileNav from "./Components/MobileNav"; // Import the MobileNav component
import ProtectedRoute from "./Components/ProtectedRoute";
import AdminPage from "./Pages/Admin";
import SubmissionDetail from "./Pages/SubmissionDetail";
import { Toaster } from "react-hot-toast";
import TermsOfService from "./Pages/TermsOfService";

function AppContent() {
  const location = useLocation();

  const showNavbar =
    location.pathname === "/" ||
    location.pathname === "/auth" ||
    location.pathname === "/forgot-password" ||
    location.pathname === "/pricing" ||
    location.pathname === "/reset-password" ||
    location.pathname === "/privacy-policy" ||
    location.pathname === '/terms-of-service';

  const showSidebar =
    location.pathname === "/dashboard" ||
    location.pathname === "/account" ||
    location.pathname === "/admin" ||
    location.pathname === "/contact-us" ||
    location.pathname.startsWith("/admin/submissions/");

  return (
    <div className="min-h-screen flex flex-col overflow-x-hidden">
      <Toaster position="top-center" />
      {showNavbar && <Navbar />}
      <div className="flex-grow flex w-full">
        <Routes>
          {/* <Route path="/" element={<Home />} /> */}
          <Route path="/" element={<Home />} />
          <Route path="/auth" element={<AuthFlow />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <div className="flex flex-grow">
                  <Sidebar />
                  <MobileNav />
                  <div className="lg:pl-64 flex-grow pt-14 lg:pt-0"> {/* Add top padding on mobile for the fixed header */}
                    <Dashboard />
                  </div>
                </div>
              </ProtectedRoute>
            }
          />
          <Route
            path="/account"
            element={
              <ProtectedRoute>
                <div className="flex flex-grow">
                  <Sidebar />
                  <MobileNav />
                  <div className="lg:pl-64 flex-grow pt-14 lg:pt-0"> {/* Add top padding on mobile for the fixed header */}
                    <Account />
                  </div>
                </div>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <div className="flex flex-grow">
                  <Sidebar />
                  <MobileNav /> {/* Add the mobile navigation */}
                  <div className="lg:pl-64 flex-grow pt-14 lg:pt-0"> {/* Add top padding on mobile for the fixed header */}
                    <AdminPage />
                  </div>
                </div>
              </ProtectedRoute>
            }
          />
          <Route
            path="/contact-us"
            element={
              <div className="flex flex-grow">
                <Sidebar />
                <MobileNav /> {/* Add the mobile navigation */}
                <div className="lg:pl-64 flex-grow pt-14 lg:pt-0"> {/* Add top padding on mobile for the fixed header */}
                  <ContactUsPage />
                </div>
              </div>
            }
          />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route
            path="/admin/submissions/:id"
            element={
              <ProtectedRoute>
                <div className="flex flex-grow bg-gray-50 dark:bg-gray-900 transition-colors duration-300">
                  <Sidebar />
                  <MobileNav />
                  <div className="lg:pl-64 flex-grow pt-14 lg:pt-0">
                    <SubmissionDetail />
                  </div>
                </div>
              </ProtectedRoute>
            }
          />
        </Routes>
      </div>
      <Footer showSidebar={showSidebar} />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
